/**
 * Initials avatar for a customer without a photo. Pure so the hover card and
 * anything else outside a store context can use it; the useCustomer
 * composable delegates here.
 */
export interface AvatarNameSource {
    first_name?: string | null;
    last_name?: string | null;
    photo_url?: string | null;
}

const COLOR_PAIRS = [
    {color: '7F9CF5', background: 'EBF4FF'}, // Blue
    {color: 'FF6B6B', background: 'FFE6E6'}, // Red
    {color: '4CAF50', background: 'E8F5E9'}, // Green
    {color: 'FFB300', background: 'FFF8E1'}, // Amber
    {color: '9C27B0', background: 'F3E5F5'}, // Purple
    {color: '00ACC1', background: 'E0F7FA'}, // Cyan
    {color: 'F06292', background: 'FCE4EC'}, // Pink
    {color: '039BE5', background: 'E3F2FD'}, // Light Blue
    {color: '8D6E63', background: 'EFEBE9'}, // Brown
    {color: '43A047', background: 'C8E6C9'}, // Dark Green
];

export const initialsFor = (customer: AvatarNameSource): string => {
    const safeFirst = (customer.first_name ?? '').trim();
    const safeLast = (customer.last_name ?? '').trim();

    if (!safeFirst && !safeLast) {
        return 'NA';
    }

    return `${safeFirst.charAt(0) || 'A'}${safeLast.charAt(0) || 'A'}`.toUpperCase();
};

export const avatarUrl = (customer: AvatarNameSource): string => {
    const initials = initialsFor(customer);

    if (initials === 'NA') {
        return 'https://ui-avatars.com/api/?name=NA&color=7F9CF5&background=EBF4FF';
    }

    const hash = initials.charCodeAt(0) + initials.charCodeAt(1);
    const selected = COLOR_PAIRS[hash % COLOR_PAIRS.length];

    return `https://ui-avatars.com/api/?name=${initials}&color=${selected.color}&background=${selected.background}`;
};
